const Scalpel = (
  <svg
    fill="#183b56"
    height="25px"
    width="25px"
    version="1.1"
    viewBox="0 0 59.413 59.413"
  >
    <g>
      <path
        d="M59.413,6.229c0-1.246-0.485-2.417-1.366-3.297c-1.818-1.819-4.776-1.817-6.595,0L18.127,36.258
   c-0.509,0.509-0.724,1.223-0.63,1.924L0.293,55.386c-0.239,0.239-0.342,0.583-0.271,0.915s0.304,0.604,0.619,0.726
   c0.164,0.063,2.188,0.818,4.924,0.818c2.709,0,6.115-0.742,9.095-3.635l7.123-7.124c0.236-0.236,0.339-0.575,0.273-0.903
   l-0.542-2.713l2.305-2.306l0.354,0.082c0.245,0.057,0.492,0.084,0.736,0.084c0.849,0,1.667-0.333,2.285-0.951L54.19,13.384
   c0-0.001,0.001-0.001,0.001-0.001l3.856-3.856C58.928,8.646,59.413,7.475,59.413,6.229z M49.883,14.863l-2.354-5.179l2.375-2.376
   l2.354,5.179L49.883,14.863z M45.997,18.749l-2.354-5.179l2.375-2.375l2.354,5.179L45.997,18.749z M21.522,40.634l-1.801,1.8
   c-0.236,0.236-0.339,0.575-0.273,0.903l0.542,2.713l-6.733,6.735c-3.621,3.515-8.03,3.262-10.333,2.799l15.708-15.708
   c0.006,0.003,0.013,0.004,0.019,0.007c0.18,0.098,0.375,0.174,0.58,0.222L21.522,40.634z M25.781,38.965
   c-0.304,0.305-0.734,0.43-1.158,0.332l-4.942-1.141c-0.052-0.012-0.083-0.038-0.114-0.064c-0.022-0.019-0.045-0.039-0.065-0.074
   c-0.011-0.021-0.028-0.043-0.034-0.063c-0.021-0.074-0.026-0.184,0.073-0.284L42.132,15.08l2.354,5.179L25.781,38.965z
    M56.633,8.113l-2.865,2.865l-2.354-5.179l1.453-1.453c0.52-0.519,1.201-0.778,1.884-0.778c0.682,0,1.363,0.259,1.883,0.778
   c0.503,0.503,0.78,1.172,0.78,1.883S57.136,7.61,56.633,8.113z"
      />
      <path
        d="M12.759,47.859l-2,2c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l2-2
   c0.391-0.391,0.391-1.023,0-1.414S13.15,47.468,12.759,47.859z"
      />
      <path
        d="M8.753,51.856c-0.18,0.19-0.29,0.45-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71c0.19,0.18,0.45,0.29,0.71,0.29
   c0.27,0,0.52-0.11,0.71-0.29c0.19-0.19,0.29-0.45,0.29-0.71c0-0.26-0.1-0.52-0.29-0.71C9.803,51.486,9.133,51.486,8.753,51.856z"
      />
    </g>
  </svg>
);

export default Scalpel;
